import React, { FunctionComponent } from 'react';
import { TableRow, TableCell as TC, TableBody as TB, Typography } from '@mui/material';
import cx from 'classnames';
import dayjs from 'dayjs';
import { Constants } from '../../../../../utils';
import { StyledTableCell } from '../ReviewsTable.styles';
import styles from './ReviewsTableBody.styles';
import ReviewsOptionsMenu from '../ReviewsOptionMenu/ReviewsOptionMenu';
import { IReviewReport } from '../../../../../interfaces/report.interface';
import useStyles from './ReviewsTableBody.styles';

interface IProps {
  reports: IReviewReport[] | null;
}

const ReviewsTableBody: FunctionComponent<IProps> = ({ reports = [] }) => {
  const classes = useStyles();
  return (
    <TB>
      {reports?.map((report) => {
        const testid = `report-${report.name}`;
        return (
          <TableRow key={report.name} data-testid={`user-${report.name}`}>
            <StyledTableCell data-testid={report.name}>
              <span className={classes.name}>{report.name}</span>
            </StyledTableCell>
            <StyledTableCell data-testid={report.updated}>
              <Typography className={classes.date} data-testid={`${testid}__date`}>
                {`${Constants.REPORT_STATUSES[report.status]?.dateText} ${dayjs(
                  report.updated
                ).format('MM/DD/YYYY | h:mm a')}`}
              </Typography>
            </StyledTableCell> 
            <StyledTableCell data-testid={`user-${report.name}__name`}>
              <span className={classes.name}>{report.user?.name}</span>
              <span className={classes.email}>{report.user?.email}</span>
            </StyledTableCell>
            <StyledTableCell data-testid={`user-${report.name}__name-of-site`}>
              {report.siteName}
            </StyledTableCell>
            <StyledTableCell data-testid={`user-${report.name}__status`}>
              <div
                className={cx(classes.status, {
                  [classes.submittedStatus]:report.status === Constants.REPORT_STATUS.SUBMITTED,
                  [classes.finishedStatus]:report.status === Constants.REPORT_STATUS.FINISHED,
                  [classes.pendingStatus]:report.status === Constants.REPORT_STATUS.PENDING,
                })}
              >
                <Typography
                  className={classes.statusText}
                  data-testid={`${testid}__status`}
                >
                  {Constants.REPORT_STATUSES[report.status].status}
                </Typography>
              </div>
            </StyledTableCell>
            <StyledTableCell data-testid={`user-${report.name}__status`}>
              <ReviewsOptionsMenu reviewStatus={report} />
            </StyledTableCell>
          </TableRow>
        );
      })}
    </TB>
  );
};

export default ReviewsTableBody;
